// source: legebill/site/v4/site.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var legebill_type_narrative_type_pb = require('../../../legebill/type/narrative_type_pb.js');
goog.object.extend(proto, legebill_type_narrative_type_pb);
var wisetime_type_site_preferences_pb = require('../../../wisetime/type/site_preferences_pb.js');
goog.object.extend(proto, wisetime_type_site_preferences_pb);
goog.exportSymbol('proto.legebill.site.v4.GetSiteRequest', null, global);
goog.exportSymbol('proto.legebill.site.v4.PostTimePreferences', null, global);
goog.exportSymbol('proto.legebill.site.v4.PostTimeRequirements', null, global);
goog.exportSymbol('proto.legebill.site.v4.Site', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.v4.GetSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.v4.GetSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.v4.GetSiteRequest.displayName = 'proto.legebill.site.v4.GetSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.v4.Site = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.v4.Site, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.v4.Site.displayName = 'proto.legebill.site.v4.Site';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.v4.PostTimeRequirements = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.v4.PostTimeRequirements, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.v4.PostTimeRequirements.displayName = 'proto.legebill.site.v4.PostTimeRequirements';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.v4.PostTimePreferences = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.v4.PostTimePreferences, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.v4.PostTimePreferences.displayName = 'proto.legebill.site.v4.PostTimePreferences';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.v4.GetSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.v4.GetSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.v4.GetSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.GetSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.v4.GetSiteRequest}
 */
proto.legebill.site.v4.GetSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.v4.GetSiteRequest;
  return proto.legebill.site.v4.GetSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.v4.GetSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.v4.GetSiteRequest}
 */
proto.legebill.site.v4.GetSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.v4.GetSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.v4.GetSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.v4.GetSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.GetSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.v4.GetSiteRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.v4.GetSiteRequest} returns this
 */
proto.legebill.site.v4.GetSiteRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.v4.Site.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.v4.Site.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.v4.Site} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.Site.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    postTimeRequirements: (f = msg.getPostTimeRequirements()) && proto.legebill.site.v4.PostTimeRequirements.toObject(includeInstance, f),
    postTimePrefs: (f = msg.getPostTimePrefs()) && proto.legebill.site.v4.PostTimePreferences.toObject(includeInstance, f),
    siteRoundingPreference: jspb.Message.getFieldWithDefault(msg, 6, 0),
    roundingPreferenceSec: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.v4.Site}
 */
proto.legebill.site.v4.Site.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.v4.Site;
  return proto.legebill.site.v4.Site.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.v4.Site} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.v4.Site}
 */
proto.legebill.site.v4.Site.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.legebill.site.v4.PostTimeRequirements;
      reader.readMessage(value,proto.legebill.site.v4.PostTimeRequirements.deserializeBinaryFromReader);
      msg.setPostTimeRequirements(value);
      break;
    case 4:
      var value = new proto.legebill.site.v4.PostTimePreferences;
      reader.readMessage(value,proto.legebill.site.v4.PostTimePreferences.deserializeBinaryFromReader);
      msg.setPostTimePrefs(value);
      break;
    case 6:
      var value = /** @type {!proto.wisetime.type.RoundingPreference} */ (reader.readEnum());
      msg.setSiteRoundingPreference(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoundingPreferenceSec(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.v4.Site.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.v4.Site.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.v4.Site} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.Site.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPostTimeRequirements();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.legebill.site.v4.PostTimeRequirements.serializeBinaryToWriter
    );
  }
  f = message.getPostTimePrefs();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.legebill.site.v4.PostTimePreferences.serializeBinaryToWriter
    );
  }
  f = message.getSiteRoundingPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRoundingPreferenceSec();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.v4.Site.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.v4.Site} returns this
 */
proto.legebill.site.v4.Site.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.legebill.site.v4.Site.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.v4.Site} returns this
 */
proto.legebill.site.v4.Site.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PostTimeRequirements post_time_requirements = 3;
 * @return {?proto.legebill.site.v4.PostTimeRequirements}
 */
proto.legebill.site.v4.Site.prototype.getPostTimeRequirements = function() {
  return /** @type{?proto.legebill.site.v4.PostTimeRequirements} */ (
    jspb.Message.getWrapperField(this, proto.legebill.site.v4.PostTimeRequirements, 3));
};


/**
 * @param {?proto.legebill.site.v4.PostTimeRequirements|undefined} value
 * @return {!proto.legebill.site.v4.Site} returns this
*/
proto.legebill.site.v4.Site.prototype.setPostTimeRequirements = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.v4.Site} returns this
 */
proto.legebill.site.v4.Site.prototype.clearPostTimeRequirements = function() {
  return this.setPostTimeRequirements(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.v4.Site.prototype.hasPostTimeRequirements = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PostTimePreferences post_time_prefs = 4;
 * @return {?proto.legebill.site.v4.PostTimePreferences}
 */
proto.legebill.site.v4.Site.prototype.getPostTimePrefs = function() {
  return /** @type{?proto.legebill.site.v4.PostTimePreferences} */ (
    jspb.Message.getWrapperField(this, proto.legebill.site.v4.PostTimePreferences, 4));
};


/**
 * @param {?proto.legebill.site.v4.PostTimePreferences|undefined} value
 * @return {!proto.legebill.site.v4.Site} returns this
*/
proto.legebill.site.v4.Site.prototype.setPostTimePrefs = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.v4.Site} returns this
 */
proto.legebill.site.v4.Site.prototype.clearPostTimePrefs = function() {
  return this.setPostTimePrefs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.v4.Site.prototype.hasPostTimePrefs = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional wisetime.type.RoundingPreference site_rounding_preference = 6;
 * @return {!proto.wisetime.type.RoundingPreference}
 */
proto.legebill.site.v4.Site.prototype.getSiteRoundingPreference = function() {
  return /** @type {!proto.wisetime.type.RoundingPreference} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.wisetime.type.RoundingPreference} value
 * @return {!proto.legebill.site.v4.Site} returns this
 */
proto.legebill.site.v4.Site.prototype.setSiteRoundingPreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional int32 rounding_preference_sec = 7;
 * @return {number}
 */
proto.legebill.site.v4.Site.prototype.getRoundingPreferenceSec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.v4.Site} returns this
 */
proto.legebill.site.v4.Site.prototype.setRoundingPreferenceSec = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.v4.PostTimeRequirements.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.v4.PostTimeRequirements.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.v4.PostTimeRequirements} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.PostTimeRequirements.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagRequired: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.v4.PostTimeRequirements}
 */
proto.legebill.site.v4.PostTimeRequirements.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.v4.PostTimeRequirements;
  return proto.legebill.site.v4.PostTimeRequirements.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.v4.PostTimeRequirements} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.v4.PostTimeRequirements}
 */
proto.legebill.site.v4.PostTimeRequirements.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTagRequired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.v4.PostTimeRequirements.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.v4.PostTimeRequirements.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.v4.PostTimeRequirements} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.PostTimeRequirements.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagRequired();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool tag_required = 1;
 * @return {boolean}
 */
proto.legebill.site.v4.PostTimeRequirements.prototype.getTagRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.legebill.site.v4.PostTimeRequirements} returns this
 */
proto.legebill.site.v4.PostTimeRequirements.prototype.setTagRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.v4.PostTimePreferences.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.v4.PostTimePreferences.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.v4.PostTimePreferences} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.PostTimePreferences.toObject = function(includeInstance, msg) {
  var f, obj = {
    narrativeType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    directTimelinePostPreference: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.v4.PostTimePreferences}
 */
proto.legebill.site.v4.PostTimePreferences.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.v4.PostTimePreferences;
  return proto.legebill.site.v4.PostTimePreferences.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.v4.PostTimePreferences} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.v4.PostTimePreferences}
 */
proto.legebill.site.v4.PostTimePreferences.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.legebill.type.NarrativeType} */ (reader.readEnum());
      msg.setNarrativeType(value);
      break;
    case 2:
      var value = /** @type {!proto.wisetime.type.DirectTimelinePostPreference} */ (reader.readEnum());
      msg.setDirectTimelinePostPreference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.v4.PostTimePreferences.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.v4.PostTimePreferences.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.v4.PostTimePreferences} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.v4.PostTimePreferences.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNarrativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDirectTimelinePostPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional legebill.type.NarrativeType narrative_type = 1;
 * @return {!proto.legebill.type.NarrativeType}
 */
proto.legebill.site.v4.PostTimePreferences.prototype.getNarrativeType = function() {
  return /** @type {!proto.legebill.type.NarrativeType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.legebill.type.NarrativeType} value
 * @return {!proto.legebill.site.v4.PostTimePreferences} returns this
 */
proto.legebill.site.v4.PostTimePreferences.prototype.setNarrativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional wisetime.type.DirectTimelinePostPreference direct_timeline_post_preference = 2;
 * @return {!proto.wisetime.type.DirectTimelinePostPreference}
 */
proto.legebill.site.v4.PostTimePreferences.prototype.getDirectTimelinePostPreference = function() {
  return /** @type {!proto.wisetime.type.DirectTimelinePostPreference} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wisetime.type.DirectTimelinePostPreference} value
 * @return {!proto.legebill.site.v4.PostTimePreferences} returns this
 */
proto.legebill.site.v4.PostTimePreferences.prototype.setDirectTimelinePostPreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.legebill.site.v4);
